import { criarRepositorio } from './createRepository';

export const repositorioCultura = criarRepositorio('cultura');
export const repositorioSafra = criarRepositorio('safra');
export const repositorioTipoAtividade = criarRepositorio('tipo_atividade');
export const repositorioAtividade = criarRepositorio('atividade');
export const repositorioPlantio = criarRepositorio('plantio');
export const repositorioColheita = criarRepositorio('colheita');
export const repositorioCustoAgricola = criarRepositorio('custo_agricola');
export const repositorioAnaliseSolo = criarRepositorio('analise_solo');
